import { ArticleType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { UserType } from 'hooks/useUserData';

export const isSuggestionAssignedToMe = ({
  suggestion,
  user,
}: {
  suggestion: ArticleType;
  user: UserType;
}) => {
  return (
    suggestion.taskOwner?.toLowerCase() === user?.username?.toLowerCase() &&
    suggestion.taskStatus !== 'CLOSED' &&
    suggestion.taskStatus !== 'COMPLETED'
  );
};

export const isSuggestionAssignedToOthers = ({
  suggestion,
  user,
}: {
  suggestion: ArticleType;
  user: UserType;
}) => {
  return (
    suggestion.createdBy?.toLowerCase() === user?.username?.toLowerCase() &&
    suggestion.taskOwner?.toLowerCase() !== user?.username?.toLowerCase() &&
    suggestion.taskStatus !== 'CLOSED' &&
    suggestion.taskStatus !== 'COMPLETED'
  );
};

export const isSuggestionClosed = ({
  suggestion,
  user,
}: {
  suggestion: ArticleType;
  user: UserType;
}) => {
  return (
    suggestion.taskOwner?.toLowerCase() === user?.username?.toLowerCase() &&
    (suggestion.taskStatus === 'CLOSED' || suggestion.taskStatus === 'COMPLETED')
  );
};
